const projects = [
  {
    id: 1,
    title: "Detailing dark theme",
    description:
      "Un șablon elegant și modern, perfect pentru site-uri ce pun accent pe detalii și prezentarea serviciilor premium. Designul întunecat adaugă un plus de sofisticare și profesionalism.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785175/yrdfinal/assets/templates/Homepage_1_aqknhu.jpg",
    slug: "detailing-dark-theme",
    categories: ["Auto", "Servicii Premium", "Business"],
  },
  {
    id: 2,
    title: "Salon / Gene false",
    description:
      "Un site dedicat saloanelor de înfrumusețare, cu un design modern și atrăgător, perfect pentru promovarea serviciilor de make-up și gene false.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785249/yrdfinal/assets/templates/Website_Landing_Page_1_g4ncxh.jpg",
    slug: "salon-light-theme",
    categories: ["Frumusețe", "Saloane", "Cosmetică"],
  },
  {
    id: 3,
    title: "Fotograf dark theme",
    description:
      "Un șablon elegant și sofisticat, ideal pentru site-uri de fotografi profesioniști. Designul în tonuri închise permite evidențierea imaginii și portofoliilor vizuale.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740560195/yrdfinal/assets/templates/Photograph_-_Desktop_wxrqxu.jpg",
    slug: "fotograf-dark-theme",
    categories: ["Fotografie", "Portofoliu", "Creativ"],
  },
  {
    id: 4,
    title: "Dentist light theme",
    description:
      "Un șablon curat și luminos, perfect pentru clinici dentare. Designul modern oferă o experiență plăcută pacienților și subliniază profesionalismul serviciilor stomatologice.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785270/yrdfinal/assets/templates/Home_-_Desktop_cswxu7.jpg",
    slug: "dentist-light-theme",
    categories: ["Medical", "Clinici", "Sănătate"],
  },
  {
    id: 5,
    title: "BarberShop dark theme",
    description:
      "Un șablon elegant și modern, destinat barbiștilor. Designul dark adaugă un aer masculinității și profesionalismului serviciilor de coafură și bărbierit.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785190/yrdfinal/assets/templates/Barber_Shop_-_1_mloo5b.jpg",
    slug: "barbershop-dark-theme",
    categories: ["Frumusețe", "Barbershop", "Saloane"],
  },
  {
    id: 6,
    title: "Personal Trainer Dark Theme",
    description:
      "Un șablon dinamic, perfect pentru antrenori personali sau centre de fitness. Designul întunecat pune accent pe energie și rezultate remarcabile în transformările fizice.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740560194/yrdfinal/assets/templates/Personal_Trainer_-_Desktop_mfvwae.jpg",
    slug: "personal-trainer-dark-theme",
    categories: ["Fitness", "Sport", "Nutriție", "Antrenori Personali"],
  },
  {
    id: 7,
    title: "Cabinet Avocatură - light theme",
    description:
      "Un șablon elegant și profesional, ideal pentru site-uri de avocatură. Designul luminos inspiră încredere și autoritate în domeniul juridic.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740566771/yrdfinal/assets/templates/DESKTOP_1_eysrip.jpg",
    slug: "cabinet-avocatură-light-theme",
    categories: ["Juridic", "Avocatură", "Servicii Profesionale"],
  },
  {
    id: 8,
    title: "Design interior - light theme",
    description:
      "Un șablon ideal pentru agenții de design interior. Designul luminos evidențiază creativitatea și profesionalismul în realizarea proiectelor de design.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785219/yrdfinal/assets/templates/Interior_Design_-_Desktop_1_stb60z.jpg",
    slug: "design-interior-light-theme",
    categories: ["Design Interior", "Arhitectură", "Creativ"],
  },
  {
    id: 9,
    title: "Design interior - dark theme",
    description:
      "Un șablon sofisticat și elegant, destinat agențiilor de design interior. Designul în culori închise subliniază eleganța și rafinamentul proiectelor realizate.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785166/yrdfinal/assets/templates/Interior_Design_-_Desktop_cy7dou.jpg",
    slug: "design-interior-dark-theme",
    categories: ["Design Interior", "Arhitectură", "Creativ"],
  },
  {
    id: 10,
    title: "Magazin de Mobilă - light theme",
    description:
      "Un șablon modern și ușor de navigat, perfect pentru magazinele de mobilă. Designul luminos pune în evidență produsele și oferă o experiență plăcută utilizatorilor.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740568357/yrdfinal/assets/templates/Mobilfy_-_Desktop_yhbziy.jpg",
    slug: "magazin-de-mobila-light-theme",
    categories: ["Mobilă", "Magazin Online", "E-commerce"],
  },
  {
    id: 11,
    title: "Portofoliu personal - light theme",
    description:
      "Un șablon perfect pentru portofolii personale sau profesionale. Designul curat și luminos subliniază realizările și competențele într-un mod elegant și simplu.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785158/yrdfinal/assets/templates/Portofoliu_-_Desktop_bvxl6a.jpg",
    slug: "portofoliu-personal-light-theme",
    categories: ["Portofoliu", "Personal", "Creativ"],
  },
  {
    id: 12,
    title: "Cabană la munte - light theme",
    description:
      "Un șablon ideal pentru cabane de vacanță sau pensiuni. Designul luminos și natural evocă o atmosferă relaxantă, perfectă pentru promovarea unei escapade montane.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740785240/yrdfinal/assets/templates/index_zmdsqk.jpg",
    slug: "cabana-la-munte-light-theme",
    categories: ["Turism", "Cazare", "Relaxare"],
  },

  {
    id: 13,
    title: "Cabană la munte - light theme 2",
    description:
      "Un șablon dedicat promovării cabanelor de munte sau pensiunilor. Designul curat și primitor atrage turiștii în căutare de relaxare și aventuri montane.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740786900/yrdfinal/assets/templates/HOTEL-02_1_fnmw6o.jpg",
    slug: "cabana-la-munte-light-theme-2",
    categories: ["Turism", "Cazare", "Relaxare", "Hoteluri", "Pensiuni"],
  },

  {
    id: 14,
    title: "Restaurant - light theme",
    description:
      "Un șablon modern și elegant pentru restaurante. Ideal pentru a prezenta meniul, rezervările online și experiența culinară într-un mod atractiv și accesibil.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740991157/yrdfinal/assets/templates/HomePage_envcdw.jpg",
    slug: "Restaurant-light-theme-2",
    categories: ["Restaurant", "Cafenea", "Culinar", "Horeca"],
  },

  {
    id: 15,
    title: "Nutritionist - light theme",
    description:
      "Un șablon dedicat nutriționiștilor care doresc să-și prezinte serviciile, planurile alimentare și să ofere consultații personalizate online.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740991157/yrdfinal/assets/templates/Nutritionist_-_Desktop_kr7ryv.jpg",
    slug: "Nutritionist-light-theme",
    categories: ["Nutriție", "Sănătate", "Fitness", "Medical"],
  },

  {
    id: 16,
    title: "Yoga - light theme",
    description:
      "Un șablon creat special pentru studiourile de yoga și instructorii independenți. Include secțiuni pentru programe, clase online și testimoniale.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740991159/yrdfinal/assets/templates/Yoga_-_Desktop_uhstw2.jpg",
    slug: "yoga-light-theme",
    categories: ["Yoga", "Fitness", "Relaxare", "Sport"],
  },

  {
    id: 17,
    title: "Magazin de Mobilă 2 - light theme",
    description:
      "Un șablon perfect pentru magazinele de mobilă care doresc să-și prezinte colecțiile într-un mod clar și rafinat, cu accent pe imagini și detalii de produs.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740991158/yrdfinal/assets/templates/Furni_-_Desktop_ukeb9o.jpg",
    slug: "magazin-de-mobila-2-light-theme",
    categories: ["Mobilă", "Magazin Online", "E-commerce", "Design Interior"],
  },

  {
    id: 18,
    title: "Coafor - light theme",
    description:
      "Un șablon elegant și modern pentru saloanele de coafură. Include secțiuni pentru servicii, programări online și portofoliu de stiluri.",
    image:
      "https://res.cloudinary.com/dsqwnuyiw/image/upload/v1740991158/yrdfinal/assets/templates/Hair_salon_-_desktop_kkelc9.jpg",
    slug: "coafor-light-theme",
    categories: ["Coafor", "Frumusețe", "Saloane", "Cosmetică"],
  },
];

export default projects;
